export enum UserSearchType {
    all = 1,
    team = 2,
    vendors = 3,
}
